import getDevice from "../utils/getDevice";
import postJsonData from "../utils/postJsonData";

const ENDPOINT_EXCEPTIONS = {
    "page-view": "user",
};

const SHORT_FULL_NAME_MAP = {
    dp: "post",
    pp: "post",
    fp: "section",
    sp: "section",
    tp: "tag",
};

function getPageTypeName(shortName) {
    return SHORT_FULL_NAME_MAP[shortName] || "public";
}

function getPageTypeFromResourceId() {
    const [resource] = window.REBELMOUSE_BOOTSTRAP_DATA.resourceId.split("_");
    return getPageTypeName(resource);
}

function makeBaseParams() {
    const device = getDevice();
    const siteId = window.REBELMOUSE_BOOTSTRAP_DATA.site.id;
    const roarId = window.REBELMOUSE_BOOTSTRAP_DATA.runner.id;
    return {
        site_id: siteId,
        roar_id: roarId,
        client: device !== "tablet" ? device : "other",
        referrer: document.referrer,
    };
}

function makeSimpleBaseParams(){
    const site_id = window.REBELMOUSE_BOOTSTRAP_DATA.site.id;
    return { site_id };
}

function sendStats(action, params, isSplitTesting) {
    const statsVersion = 1;
    const statsFormat = "json";

    const requestParams = isSplitTesting ? {...makeSimpleBaseParams(), ...params} : {...makeBaseParams(), ...params};

    const query = {
        event: action,
        version: statsVersion,
        format: statsFormat,
        data: JSON.stringify(requestParams),
    };

    const prefix = isSplitTesting ? "split-testing" : ENDPOINT_EXCEPTIONS[action] || "pages";
    const paramsStr = new URLSearchParams(query).toString();

    const statsUrl = `https://${prefix}-stats.rbl.ms/spacer.gif?${Date.now()}&${paramsStr}`;

    fetch(statsUrl);
}

function addSplitTestingParams(params, splitTesting) {
    const {
        current: { campaign_id, hypothesis_id },
    } = splitTesting;
    return { ...params, campaign_id, hypothesis_id };
}

function checkIfPostHasSplitTesting(post) {
    return post && post.split_testing && post.split_testing.current;
}

function trackPageView(data) {
    const { post, id } = data;

    let params;
    let isSplitTesting = false;

    if (post) {
        params = {
            post_id: data.id,
            provider_id: post.providerId,
            sections: post.sections,
            buckets: post.buckets,
            authors: post.authors,
        };

        isSplitTesting = checkIfPostHasSplitTesting(post);

        if (isSplitTesting) {
            params = addSplitTestingParams(params, post.split_testing);
        }
    } else {
        params = {
            section_id: 0,
            sections: [0],
        };
    }

    const action = isSplitTesting || id ? "post-page-view" : "section-page-view";

    sendStats(action, params, isSplitTesting);
}

function trackTimeOnPage({ timeMarker }) {
    sendStats(`${getPageTypeFromResourceId()}-page-view-duration`, {
        duration: timeMarker,
    });
}

function getUserTrackingId() {
    const trackingId = localStorage.getItem("userTrackingId");
    const prevLoggedStatus = localStorage.getItem("userTrackingLoggedStatus") === "true";
    if (trackingId && prevLoggedStatus === window.REBELMOUSE_BOOTSTRAP_DATA.isUserLoggedIn) {
        return Promise.resolve(trackingId);
    }
    const newVisitorData = {
        user_tracking_id: null,
        last_page_view_timestamp: null,
        user_type: "casual",
    };

    return postJsonData(
        `${window.REBELMOUSE_BASE_SSL_DOMAIN}/core/users/tracking/`,
        newVisitorData
    ).then((data) => {
        const { user_tracking_id } = data;
        localStorage.setItem("userTrackingId", user_tracking_id);
        localStorage.setItem(
            "userTrackingLoggedStatus",
            window.REBELMOUSE_BOOTSTRAP_DATA.isUserLoggedIn
        );
        return user_tracking_id;
    });
}

function trackUser() {
    const mainPost = window.REBELMOUSE_BOOTSTRAP_DATA.post;
    getUserTrackingId().then((trackingId) => {
        const data = {
            user_tracking_id: trackingId,
        };

        if (Object.keys(mainPost).length > 0) {
            data.post_id = mainPost.id;
            data.sections = mainPost.sections;
            data.tags = mainPost.tags;
        }
        sendStats("page-view", data);
    });
}

function trackPostCardClick({ id, post }) {
    const params = {
        post_id: id,
        provider_id: post.providerId,
        sections: post.sections,
    };

    const isSplitTesting = checkIfPostHasSplitTesting(post);

    if (isSplitTesting) {
        sendStats("post-card-click", addSplitTestingParams(params, post.split_testing), true);
    } else {
        sendStats("post-card-click", params);
    }
}

function batchPostCardView(posts) {
    sendStats("batch-post-card-view", { posts }, true);
}

export default {
    trackPageView,
    trackTimeOnPage,
    trackUser,
    trackPostCardClick,
    batchPostCardView
};
